import React from "react";
import greenTick from "../../assets/images/greenTick.png";
import { Button } from "reactstrap";
import { useNavigate } from "react-router";

const ForgotHome = () => {
  const navigate = useNavigate();
  return (
    <div className="page-wrapper full-page home_forgot_blk">
      <div className="header-wrapper w-nav">
        <div className="container-default w-container">
          <div className="header-content-wrapper">
            <div className="header-middle header-v3 head-tick">
                <img
                  src={greenTick}
                  alt="text_logo"
                  className="logo_png"
                />
            </div>
          </div>
          <div>
            <h2 className="text-center my-4">
              Password reset instructions has been sent to your registered
              email.
            </h2>
          </div>
          <div className="text-center">
          <Button type="button" className="home_btn home_for" onClick={()=>navigate("/login")}>
              Home
          </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotHome;
